import { getSubState } from '../../../reducers/subReducerHelpers';
import { buildPriceLevelQuantityArray } from '../reducers/ticket-picker';
import { getIsTicketPickerAdditive } from '../selectors/ticket-picker'

export const INCREMENT_PRICE_LEVEL = "INCREMENT_PRICE_LEVEL";
export const DECREMENT_PRICE_LEVEL = "DECREMENT_PRICE_LEVEL";
export const SET_PRICE_LEVEL = "SET_PRICE_LEVEL";
export const SET_NEW_QUANTITIES = "SET_NEW_QUANTITIES";
export const CLEAR_SELECTED_PRICE_LEVELS = "CLEAR_SELECTED_PRICE_LEVELS";
export const SET_DISPLAY_CONFIGURATION_ERROR = "SET_DISPLAY_CONFIGURATION_ERROR";
export const PRICE_LEVEL_SET_PWYW_PRICE = "PRICE_LEVEL_SET_PWYW_PRICE";
export const TICKET_PICKER_SET_QUANTITY_ARRAY_FOR_LEVEL = "TICKET_PICKER_SET_QUANTITY_ARRAY_FOR_LEVEL";

export function incrementPriceLevel(id, subReducerKey = null) {
    return (dispatch, getState) => {
        let state = getState();
        let level = getSubState(state.priceLevel, subReducerKey)?.levels?.[id];
        let quantity = state.ticketPicker.quantities[id];

        if(level && quantity === +level.transaction_limit) {
            return;
        }

        dispatch({type: INCREMENT_PRICE_LEVEL, id, subReducerKey});
    }
}

export function decrementPriceLevel(id, subReducerKey = null) {
    return {type: DECREMENT_PRICE_LEVEL, id, subReducerKey};
}

export function setPriceLevel(id, value, subReducerKey = null) {
    return {type: SET_PRICE_LEVEL, id, value, subReducerKey};
}

export function setPriceLevelsQuantities(quantities, subReducerKey = null) {
    return {type: SET_NEW_QUANTITIES, quantities, subReducerKey};
}

export function clearSelectedPriceLevels(subReducerKey = null) {
    return {type: CLEAR_SELECTED_PRICE_LEVELS, subReducerKey};
}

export function setDisplayConfigurationError(value, subReducerKey = null) {
    return {type: SET_DISPLAY_CONFIGURATION_ERROR, value, subReducerKey};
}

export function setPWYWPrice(id, price, subReducerKey = null) {
    return {type: PRICE_LEVEL_SET_PWYW_PRICE, id, price, subReducerKey};
}

// manually set the quantity array on the ticket picker state for the provided price level
const setQuantityArrayForPriceLevel = (priceLevelId, quantityArray, subReducerKey = null) => {
    return {type: TICKET_PICKER_SET_QUANTITY_ARRAY_FOR_LEVEL, priceLevelId, quantityArray, subReducerKey};
}

// update the quantities for the provided level to subtract number of tickets in the cart
const applyCartedTicketsToQuantitiesForLevel = (priceLevelId, countOfLevel, subReducerKey = null) => {
    return (dispatch, getState) => {
         const state = getState();
         const level = getSubState(state.priceLevel, subReducerKey)?.levels?.[priceLevelId];
         if (level && countOfLevel) {
            const defaultQuantities = buildPriceLevelQuantityArray(
                level.minimum_purchase_limit,
                level.transaction_limit,
                level.increment_by
            );
            const updatedQuantites = defaultQuantities
                .map(q => q - countOfLevel) // subtract num of tickets already carted from potential quantity
                .filter(q => q > 0); // remove negative values

            dispatch(setQuantityArrayForPriceLevel(priceLevelId, updatedQuantites, subReducerKey));
        }
    }
}

// initialize ticket picker quantities from tickets already in the cart (e.g. when user returns to picker)
export const initializeQuantitiesFromCartedTickets = (subReducerKey = null) => {
    return (dispatch, getState) => {
        const state = getState();
        // skip for additive/dynamic listings where quantities represent a delta, not the cart total
        if (getIsTicketPickerAdditive(state)) {
            return;
        }
        const tickets = state.tickets.tickets;
        const ticketPickerState = getSubState(state.ticketPicker, subReducerKey);

        // Reset so stale selections don't persist if the cart was edited since last visit
        dispatch({ type: 'TICKET_PICKER_RESET_QUANTITIES', subReducerKey });

        const countsByLevelId = {};
        tickets.forEach(ticket => {
            if (ticket.price_level_id && !ticket.listing_upsell_id) {
                countsByLevelId[ticket.price_level_id] = (countsByLevelId[ticket.price_level_id] || 0) + 1;
            }
        });

        Object.entries(countsByLevelId).forEach(([levelId, count]) => {
            if (Array.isArray(ticketPickerState.quantityArrays[levelId])) {
                dispatch(setPriceLevel(levelId, count, subReducerKey));
            }
        });
    };
};

// update quantity arrays for all price levels in the ticket picker by applying all carted tickets
export const applyCartedTicketsToQuantitiesForAllLevelsInTicketPicker = (subReducerKey = null) => {
    return (dispatch, getState) => {
        if (!subReducerKey) { // not sure if this should apply to upsell, so skipping it for now
            const state = getState();
            if (getIsTicketPickerAdditive(state)) {
                const tickets = state.tickets.tickets;
                const ticketCountsByLevelId = {};
                tickets.forEach(ticket => {
                    if (ticket.price_level_id && !ticketCountsByLevelId[ticket.price_level_id]) {
                        ticketCountsByLevelId[ticket.price_level_id] = 0;
                    }
                    ticketCountsByLevelId[ticket.price_level_id]++;
                });
                Object.keys(ticketCountsByLevelId).forEach(priceLevelId => {
                    dispatch(applyCartedTicketsToQuantitiesForLevel(priceLevelId, ticketCountsByLevelId[priceLevelId], subReducerKey));
                });
            }
        }
    }
}
